import React from "react";
import {APH_LOAN_STATUS_LIST} from "./aphLoanConstants";
import {ButtonIconCopyClipboard, SelectField, TextArea} from "@components/Inputs";
import {convertCamelCaseToSpaceDelimited} from "@utilities/commonUtilities";
import {HtmlDisplay} from "@components/Display";
import {PATRON_SUBTYPE_LIST} from "@components/Authorize/roleConstants";
import {AphLoanItem} from "./aphLoan.types";
import type {ListItem} from "@utilities/Types/listUtilities";
import {formatShippingAddress} from "./aphLoanUtility";
import {GridCell, gridConstants, GridContainer} from "@components/Grid";

interface AphLoanEditFormViewProps {
    aphLoanItemForDialog: AphLoanItem;
    handleCopyAddressToClipboard: (item: AphLoanItem) => Promise<void>;
    handleCopyEmailToClipboard: (item: AphLoanItem) => Promise<void>;
    setAphLoanItemForDialog: (item: AphLoanItem) => void;
}

export const AphLoanEditFormView = ({
                                        aphLoanItemForDialog,
                                        handleCopyAddressToClipboard,
                                        handleCopyEmailToClipboard,
                                        setAphLoanItemForDialog
                                    }: AphLoanEditFormViewProps) => {

    const handleAphLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setAphLoanItemForDialog({...aphLoanItemForDialog, aphLoanStatus: event.target.value});
    }

    const handleAphLoanNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setAphLoanItemForDialog({...aphLoanItemForDialog, aphLoanNotes: event.target.value});
    }

    return <>
        {
            aphLoanItemForDialog.patronSubType &&
            <GridContainer>
                <HtmlDisplay
                    html={`Patron Role: ${PATRON_SUBTYPE_LIST.find((f: ListItem) => f.value === aphLoanItemForDialog.patronSubType)?.text || ``}`}
                    name={`patron-subtype-${aphLoanItemForDialog.aphLoanItemId}`}
                />
            </GridContainer>
        }
        {
            aphLoanItemForDialog.patronEmail &&
            <GridContainer>
                <GridCell small_columns={gridConstants.column.TWELVE}>
                    <HtmlDisplay
                        html={`Patron email: ${aphLoanItemForDialog.patronEmail}`}
                        name={`patron-email-${aphLoanItemForDialog.aphLoanItemId}`}
                    />
                </GridCell>
                <ButtonIconCopyClipboard
                    inputDescription={`patron email for ${aphLoanItemForDialog.patronFullName}`}
                    onClick={async () => await handleCopyEmailToClipboard(aphLoanItemForDialog)}
                />
            </GridContainer>
        }

        <hr/>

        <GridContainer>
            <GridCell small_columns={gridConstants.column.TWELVE}>
                <HtmlDisplay
                    html={`Shipping Address:<br>${formatShippingAddress(aphLoanItemForDialog.shippingLocation).replace(/\n/g, '<br>')}`}
                    name={`shipping-address-${aphLoanItemForDialog.aphLoanItemId}`}
                />
            </GridCell>
            <ButtonIconCopyClipboard
                inputDescription={`shipping address for ${aphLoanItemForDialog.patronFullName}`}
                onClick={async () => await handleCopyAddressToClipboard(aphLoanItemForDialog)}
            />
        </GridContainer>

        <hr/>

        <SelectField
            includeDefaultOption={false}
            label={convertCamelCaseToSpaceDelimited("AphLoanStatus", true)}
            name={"AphLoanStatus"}
            onChange={handleAphLoanStatusChange}
            options={APH_LOAN_STATUS_LIST}
            value={aphLoanItemForDialog.aphLoanStatus}
        />

        <TextArea
            label={"Aph Loan Notes"}
            name={"aphLoanNotes"}
            onChange={handleAphLoanNotesChange}
            value={aphLoanItemForDialog.aphLoanNotes}
        />
    </>;
};
